<div class="app-main__inner">
  <div class="bb-list-view">
    <div class="card bb-fill-card">
      <div class="card-header d-flex align-items-center justify-content-between">
        <span class="fw-semibold"><i class="pe-7s-print me-2 text-primary"></i>Print Barcode Labels</span>
        <span class="badge bg-secondary">{{ allRecords.length }} books</span>
      </div>

      <!-- ── Label size + Printer selector bar ──────────────── -->
      <div class="bb-layout-bar">

        <span class="bb-layout-bar__label"><i class="pe-7s-print me-1"></i>Label:</span>
        <span class="bb-layout-bar__meta">
          <span class="badge bg-dark text-white me-1" style="font-size:0.68rem; vertical-align:middle;">ZPL</span>
          50mm×25mm · 203 DPI
        </span>

        <span class="bb-bar-sep"></span>
        <span class="bb-layout-bar__label"><i class="pe-7s-print me-1"></i>Printer:</span>

        <!-- Detecting -->
        <span class="text-muted small d-flex align-items-center gap-1" *ngIf="isPrintersLoading">
          <span class="spinner-border spinner-border-sm"></span>Detecting…
        </span>

        <ng-container *ngIf="!isPrintersLoading">
          <!-- Printers found -->
          <ng-container *ngIf="zebraPrinters.length > 0">
            <span class="bb-printer-dot"></span>
            <select class="form-select form-select-sm bb-printer-select"
                    [(ngModel)]="selectedPrinterUid">
              <option *ngFor="let p of zebraPrinters" [value]="p.uid">
                {{ p.name || p.uid }}
              </option>
            </select>
          </ng-container>

          <!-- None found -->
          <span *ngIf="zebraPrinters.length === 0"
                class="bb-printer-warn small"
                [title]="printersError">
            <i class="pe-7s-attention me-1"></i>No printers found
          </span>
        </ng-container>

        <!-- Refresh button -->
        <button class="btn btn-sm bb-refresh-btn"
                [disabled]="isPrintersLoading"
                (click)="refreshPrinters()"
                title="Refresh printer list">
          <i class="pe-7s-refresh"></i>
        </button>

      </div>

      <div class="card-body p-0 bb-fill-body">

        <div class="text-center py-5" *ngIf="isListLoading">
          <div class="spinner-border text-primary"></div>
          <p class="mt-2 text-muted">Loading books...</p>
        </div>

        <div class="alert alert-danger d-flex align-items-center gap-2 m-3" *ngIf="!isListLoading && loadError">
          <i class="pe-7s-close-circle"></i>
          <span class="flex-grow-1">{{ loadError }}</span>
          <button class="btn btn-sm btn-outline-danger" (click)="loadBooks()">Retry</button>
        </div>

        <vio-table-v2
          *ngIf="!isListLoading && !loadError"
          [tableData]="allRecords"
          [tableConfig]="tableConfig">
        </vio-table-v2>

      </div>
    </div>
  </div>
</div>

<!-- ── Reprint Modal ──────────────────────────────────────── -->
<div *ngIf="showReprintModal"
     class="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center"
     style="background: rgba(0,0,0,.52); z-index: 1055; align-items: flex-start; overflow-y: auto; padding: 72px 16px 24px;"
     (click)="closeReprintModal()">

  <div class="card shadow-lg bb-reprint-modal"
       (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="card-header d-flex align-items-center justify-content-between py-3">
      <div class="d-flex align-items-center gap-2">
        <i class="pe-7s-refresh text-secondary fs-5"></i>
        <div>
          <span class="fw-bold">Reprint Barcode Label</span>
          <div class="text-muted small mt-0" style="line-height:1.2;">{{ reprintBook?.bookName }}</div>
        </div>
      </div>
      <button class="btn-close" (click)="closeReprintModal()"></button>
    </div>

    <div class="card-body">

      <!-- Book info strip -->
      <div class="bb-book-info-strip mb-4">
        <div class="bb-book-info-icon"><i class="pe-7s-bookmarks"></i></div>
        <div class="bb-book-info-text">
          <div class="fw-semibold">{{ reprintBook?.bookName }}</div>
          <div class="text-muted small">
            {{ (reprintBook?.authorNames?.length > 0 ? reprintBook.authorNames.join(', ') : reprintBook?.author) || 'Unknown author' }}
            <span *ngIf="reprintBook?.bookId"> · <code>{{ reprintBook?.bookId }}</code></span>
          </div>
          <div class="mt-1">
            <span class="badge bg-info text-dark">{{ reprintBook?.copiesAvailable }} copies available</span>
            <span class="badge bg-secondary ms-1" *ngIf="!isLoadingInventory">{{ inventorySrNos.length }} copies in inventory</span>
          </div>
        </div>
      </div>

      <!-- Label field toggles -->
      <div class="bb-field-toggles mb-3">
        <span class="bb-field-toggles__label">Show on label:</span>
        <label class="form-check form-check-inline mb-0">
          <input class="form-check-input" type="checkbox" [(ngModel)]="showClientName" id="rpShowClientName">
          <span class="form-check-label small fw-semibold">
            Client Name
            <span class="text-muted fw-normal" *ngIf="clientNameStr"> ({{ clientNameStr }})</span>
          </span>
        </label>
      </div>

      <!-- Loading -->
      <div class="text-center py-4" *ngIf="isLoadingInventory">
        <div class="spinner-border text-secondary"></div>
        <p class="mt-2 text-muted small">Loading serial numbers...</p>
      </div>

      <!-- Empty -->
      <div class="text-center py-3 text-muted" *ngIf="!isLoadingInventory && inventorySrNos.length === 0">
        <i class="pe-7s-barcode" style="font-size:2.5rem;opacity:.35;"></i>
        <p class="mt-2 small">No inventory copies found for this book.</p>
      </div>

      <!-- Print fallback reason -->
      <div class="alert alert-warning d-flex align-items-start gap-2 py-2 small" *ngIf="reprintFailReason">
        <i class="pe-7s-attention mt-1"></i>
        <span>{{ reprintFailReason }}</span>
      </div>

      <!-- Serial number buttons -->
      <ng-container *ngIf="!isLoadingInventory && inventorySrNos.length > 0">
        <div class="bb-reprint-hint mb-2">
          <i class="pe-7s-info me-1"></i>
          Click a serial number to print its barcode label.
        </div>
        <div class="bb-srno-btn-grid">
          <button class="bb-srno-btn"
                  *ngFor="let srNo of inventorySrNos"
                  (click)="reprintSingle(srNo)"
                  title="Print label for copy #{{ srNo }}">
            <i class="pe-7s-barcode"></i>
            <span>{{ srNo }}</span>
          </button>
        </div>
      </ng-container>

    </div>

    <div class="card-footer d-flex justify-content-end">
      <button class="btn btn-outline-secondary btn-sm" (click)="closeReprintModal()">Close</button>
    </div>

  </div>
</div>

<!-- ── Label Generation Modal ─────────────────────────────── -->
<div *ngIf="showModal"
     class="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center"
     style="background: rgba(0,0,0,.52); z-index: 1055; align-items: flex-start; overflow-y: auto; padding: 72px 16px 24px;"
     (click)="closeModal()">

  <div class="card shadow-lg bb-label-modal"
       (click)="$event.stopPropagation()">

    <!-- Modal Header -->
    <div class="card-header d-flex align-items-center justify-content-between py-3">
      <div class="d-flex align-items-center gap-2">
        <i class="pe-7s-print text-primary fs-5"></i>
        <div>
          <span class="fw-bold">Print Barcode Labels</span>
          <div class="text-muted small mt-0" style="line-height: 1.2;">
            {{ selectedBook?.bookName }}
          </div>
        </div>
      </div>
      <button class="btn-close" (click)="closeModal()"></button>
    </div>

    <!-- ── STEP 1: Enter copies ── -->
    <div class="card-body" *ngIf="step === 'input'">

      <!-- Book info strip -->
      <div class="bb-book-info-strip mb-4">
        <div class="bb-book-info-icon">
          <i class="pe-7s-bookmarks"></i>
        </div>
        <div class="bb-book-info-text">
          <div class="fw-semibold">{{ selectedBook?.bookName }}</div>
          <div class="text-muted small">
            {{ (selectedBook?.authorNames?.length > 0 ? selectedBook.authorNames.join(', ') : selectedBook?.author) || 'Unknown author' }}
            <span *ngIf="selectedBook?.bookId"> · <code>{{ selectedBook?.bookId }}</code></span>
          </div>
          <div class="mt-1">
            <span class="badge bg-info text-dark">{{ selectedBook?.copiesAvailable }} copies available</span>
          </div>
        </div>
      </div>

      <!-- Center badge -->
      <div class="alert alert-info d-flex align-items-center gap-2 py-2 mb-3" *ngIf="selectedCenter">
        <i class="pe-7s-home"></i>
        <span class="small">
          Labels will be assigned to center:
          <strong>{{ selectedCenter.centerName }}</strong>
          <span *ngIf="selectedCenter.area"> · {{ selectedCenter.area }}</span>
        </span>
      </div>

      <!-- Error -->
      <div class="alert alert-danger d-flex align-items-center gap-2 py-2" *ngIf="errorMessage">
        <i class="pe-7s-close-circle"></i>
        <span>{{ errorMessage }}</span>
      </div>

      <!-- Label field toggles -->
      <div class="bb-field-toggles mb-3">
        <span class="bb-field-toggles__label">Show on label:</span>
        <label class="form-check form-check-inline mb-0">
          <input class="form-check-input" type="checkbox" [(ngModel)]="showClientName" id="gcShowClientName">
          <span class="form-check-label small fw-semibold">
            Client Name
            <span class="text-muted fw-normal" *ngIf="clientNameStr"> ({{ clientNameStr }})</span>
          </span>
        </label>
      </div>

      <!-- Copies input -->
      <div class="mb-4">
        <label class="form-label fw-semibold">
          Number of Copies to Generate
          <span class="text-danger">*</span>
        </label>
        <div class="d-flex align-items-center gap-2">
          <button class="btn btn-outline-secondary btn-sm bb-stepper-btn"
                  [disabled]="copies <= 1"
                  (click)="copies = copies - 1">
            <i class="pe-7s-less"></i>
          </button>
          <input type="number" class="form-control text-center bb-copies-input"
                 [(ngModel)]="copies" min="1" max="200"
                 [class.is-invalid]="copies < 1 || copies > 200" />
          <button class="btn btn-outline-secondary btn-sm bb-stepper-btn"
                  [disabled]="copies >= 200"
                  (click)="copies = copies + 1">
            <i class="pe-7s-plus"></i>
          </button>
        </div>
        <div class="form-text mt-1">
          Enter 1–200 copies. Each copy will get a unique serial number and inventory entry.
        </div>
        <div class="invalid-feedback d-block" *ngIf="copies < 1 || copies > 200">
          Copies must be between 1 and 200.
        </div>
      </div>

      <!-- Preview note -->
      <div class="alert alert-light border d-flex gap-2 py-2 mb-3">
        <i class="pe-7s-info text-primary mt-1" style="font-size:1.1rem;"></i>
        <div class="small">
          Serial numbers are <strong>global sequential integers</strong> (e.g. <code>51</code>, <code>52</code>…)
          continuing from the last entry in the inventory. Each will be added to the book inventory
          and can be scanned immediately.
        </div>
      </div>

      <div class="d-flex gap-2 justify-content-end">
        <button class="btn btn-outline-secondary" (click)="closeModal()">Cancel</button>
        <button class="btn btn-primary" (click)="generateLabels()"
                [disabled]="isGenerating || copies < 1 || copies > 200">
          <span *ngIf="!isGenerating">
            <i class="pe-7s-magic-wand me-1"></i> Generate Labels
          </span>
          <span *ngIf="isGenerating" class="d-flex align-items-center gap-2">
            <span class="spinner-border spinner-border-sm"></span>
            Generating...
          </span>
        </button>
      </div>
    </div>

    <!-- ── STEP 2: Generated serial numbers ── -->
    <div class="card-body" *ngIf="step === 'result'">

      <!-- Success banner -->
      <div class="bb-success-banner mb-3">
        <div class="bb-success-icon"><i class="pe-7s-check"></i></div>
        <div>
          <div class="fw-bold">{{ generatedSrNos.length }} label{{ generatedSrNos.length !== 1 ? 's' : '' }} generated!</div>
          <div class="small text-muted">
            Serial numbers added to inventory for
            <strong>{{ selectedBook?.bookName }}</strong>
          </div>
        </div>
      </div>

      <!-- SR number grid -->
      <div class="bb-srno-grid">
        <div class="bb-srno-chip" *ngFor="let srNo of generatedSrNos">
          <i class="pe-7s-barcode"></i>
          <span>{{ srNo }}</span>
        </div>
      </div>

      <!-- Print fallback reason -->
      <div class="alert alert-warning d-flex align-items-start gap-2 py-2 small mt-3" *ngIf="printFailReason">
        <i class="pe-7s-attention mt-1"></i>
        <span>{{ printFailReason }}</span>
      </div>

      <div class="d-flex gap-2 justify-content-between mt-3 flex-wrap">
        <button class="btn btn-outline-secondary btn-sm" (click)="step = 'input'; generatedSrNos = []">
          <i class="pe-7s-back me-1"></i> Generate More
        </button>
        <div class="d-flex gap-2">
          <button class="btn btn-outline-secondary" (click)="closeModal()">Close</button>
          <button class="btn btn-success" (click)="printLabels()">
            <i class="pe-7s-print me-1"></i>
            Print Barcodes ({{ generatedSrNos.length }})
          </button>
        </div>
      </div>

    </div>

  </div>
</div>
